<template>
  <div
    v-if="groups?.length"
    :class="$style.root"
  >
    <div
      v-if="images"
      ref="carouselElement"
      :class="$style.carousel"
    >
      <CoreImageCarouselComponent
        :images="images"
        :slideToIndex="activeImageIndex"
        @setActiveIndex="activeImageIndex = $event"
      />
    </div>

    <div
      v-if="label"
      :class="$style.label"
    >
      {{ label }}
    </div>

    <ul :class="$style.list">
      <li
        v-for="group in groups"
        :class="$style.item"
      >
        <div :class="$style.itemLabel">
          {{ group?.label }}
        </div>
        <div>
          <component
            v-for="item in group?.items"
            :is="item?.image?.data?.id ? 'button' : 'div'"
            :class="item?.image?.data?.id ? $style.button : null"
            @click="item?.image?.data?.id ? slideToId(item?.image?.data?.id) : null"
            :data-current="activeImageId === item?.image?.data?.id ? '' : null"
          >
            {{ item?.name }}
          </component>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  const carouselElement = ref(null)

  const props = defineProps({
    label: {
      type: String,
      required: false,
    },
    groups: {
      type: Array,
      required: true
    }
  })

  const images = computed(() => {
    return props?.groups.map((group) => {
      return group.items.map((item) => {
        return {
          ...item.image?.data,
          attributes: {
            ...item.image?.data?.attributes,
            caption: [item?.name?.trim(), group?.label?.trim()]?.filter(i => i).join(', '),
            captionEn: [item?.name?.trim(), group?.label?.trim()]?.filter(i => i).join(', ')
          }
        }
      })
    })?.flat()?.filter(i => i?.id)
  })

  const activeImageId = computed(() => images.value?.[activeImageIndex.value]?.id)

  const activeImageIndex = ref(0)
  const slideToId = (id) => {
    const index = images.value?.findIndex((image) => image?.id === id)
    if (index !== -1) {
      activeImageIndex.value = index
      const offset = document?.getElementById('site-header')?.getBoundingClientRect()?.height || 70
      window.scrollTo({
        top: carouselElement.value?.offsetTop - offset,
        behavior: 'smooth'
      })
    }
  }
</script>

<style module>
.root {
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

.carousel {
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.label {
  composes: font-helvetica font-size-small label-border from global;
  text-align: center;
}

.list {
  composes: reset-list from global;

  columns: 2;

  margin-top: calc( (var(--font-default--line-height) / 2) * -1 );
  margin-bottom: calc( (var(--font-default--line-height) / 2) * -1 );
}

.item {
  padding: calc(var(--font-default--line-height) / 2) 0;
  break-inside: avoid;
}

.itemLabel {
  composes: font-helvetica font-size-small from global;
  line-height: var(--font-default--line-height);
}

.value {
  composes: font-size-default from global;
}

.button {
  composes: reset-button font-size-default from global;
}

.button:not(:hover):not([data-current]):first-letter {
  text-decoration-line: underline;
}

.button:hover,
.button[data-current] {
  text-decoration-line: underline;
}

</style>
